import React, { useMemo } from 'react';
import { FlexAnchorStyled, FlexLinkStyled } from '@yme/molecules/buttons';
import { isExternalLink } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
export const useLink = ({ children, buttonLink = '', className, onClick }) => {
    const isLinkExternal = isExternalLink(buttonLink);
    const LinkComponent = useMemo(() => {
        return function getLinkComponent() {
            return isLinkExternal ? (React.createElement(FlexAnchorStyled, { href: buttonLink, target: BLANK, className: className }, children)) : (React.createElement(FlexLinkStyled, { to: buttonLink, target: SELF, className: className, onClick: onClick }, children));
        };
    }, [buttonLink, children, className, isLinkExternal, onClick]);
    return {
        LinkComponent,
    };
};
